export const capitalizeFirstLetter = (text) => {
    if (typeof text !== 'string') {
        return text;
    } else if (text.length === 0) {
        return text;
    }
    text = text.toLowerCase();
    return text.charAt(0).toUpperCase() + text.slice(1);
}



